export var NOT_SHARED = 1;